import React from "react"
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
class EditStores extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addStores:
            {
                storeId: 0,
                name: "",
                material: "",
                location: "",
                remarks: "",
                parts: "",
                quantity: "",
                unit: "",
                pchmchm: "",
                isDeleted: false,
                isUpdated: true,
                createdBy: "",
                modifiedBy: ""
            },
            Stores: []
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    hideSidePanel = () => {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.goBack();
    }

    static getDerivedStateFromProps(props, state) {
        if (props.StoreList) {
            state.Stores = props.StoreList;
        }
        if (props.StoreDetails) {
            state.addStores = props.StoreDetails;
            state.addStores.isUpdated = true;
        }
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.addStores[nodeName] = e.target.value;
        this.setState({});
    }

    addStoresDetails() {
        this.state.Stores.unshift(this.state.addStores);
        this.props.dispatch({ type: "GetStoreList", data: this.state.Stores });
        this.setState({addStores:
            {
                storeId: 0,
                name: "",
                material: "",
                location: "",
                remarks: "",
                parts: "",
                quantity: "",
                unit: "",
                pchmchm: "",
                isDeleted: false,
                isUpdated: true,
                createdBy: "",
                modifiedBy: ""
            }});
        // this.hideSidePanel();
    }

    UpdateStoresDetails() {
        const { addStores } = this.state;
        var index = this.state.Stores.findIndex(x => x.storeId === addStores.storeId);
        if (index === -1) {
            // handle error
        }
        else {
            this.setState({
                Stores: [
                    ...this.state.Stores.slice(0, index),
                    Object.assign({}, this.state.Stores[index], addStores),
                    ...this.state.Stores.slice(index + 1)
                ]
            }, () => {
                this.props.dispatch({ type: "GetStoreSuccess", data: this.state.Stores });
                this.hideSidePanel();
            });
        }
    }

    cancel() {
        this.hideSidePanel();
    }


    render() {
        const { EditMaterial } = this.props;

        return (
            <div className="row" style={{ paddingBottom: '338px' }}>
                <div className="full-height pt-3">
                    <div className="grey-bg  course-list-page">
                        <div className="panel-box  search-filter-box mb-4">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                        </button>
                            <div className="resource-list-auth-date">
                                <div className="card mt-2 MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            {EditMaterial ? "Edit " : "Add "} Stores
                                    </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Name </label><br></br>
                                                <input type="text" className="form-control" name="name" value={this.state.addStores.name} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Location </label><br></br>
                                                <input type="text" className="form-control" name="location" value={this.state.addStores.location} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Materials </label><br></br>
                                                <input type="text" className="form-control" name="material" value={this.state.addStores.material} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Parts </label><br></br>
                                                <input type="text" className="form-control" name="parts" value={this.state.addStores.parts} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-12 col-sm-12">
                                                <label className="form-label">Remarks </label><br></br>
                                                <textarea className="form-control" name="remarks" value={this.state.addStores.remarks} onChange={e => this.handleInputChange(e)} ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            Approximate Quantity
                                    </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Quantity </label><br></br>
                                                <input type="text" className="form-control" name="quantity" value={this.state.addStores.quantity} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Unit </label><br></br>
                                                <input type="text" className="form-control" name="unit" value={this.state.addStores.unit} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">PCHM / CHM </label><br></br>
                                                <input type="text" className="form-control" name="pchmchm" value={this.state.addStores.pchmchm} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 search-filter-box mt-2">
                                        <div className=" search-btn-col" style={{ textAlign: "end" }}>
                                            {!EditMaterial ?
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.addStoresDetails()}
                                                >
                                                    {" "}Add{" "}
                                                </button>
                                                :
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.UpdateStoresDetails()}
                                                >
                                                    {" "}Update{" "}
                                                </button>
                                            }
                                            <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                type="button" onClick={() => this.cancel()}
                                            >
                                                {" "}Cancel{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        ShowSidePan: state.SidePanReducer.sidePan || false,
        StoreList: state.MMPLDashboardReducer.StoreList || [],
        EditMaterial: state.MasterScreenReducer.EditMaterial,
        StoreDetails: state.MasterScreenReducer.StoreDetails
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditStores));